import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { CanvaIcon, CanvaSearchResultIcon } from './icon';

export const canvaConfig: ThirdPartyConfig = {
	displayName: 'Canva',
	id: 'canva',
	resourceType: ProductResourceTypes3P.Canva,
	icon: get3PLogo(CanvaIcon, 'Canva', 'medium'),
	searchResultIcon: get3PLogo(CanvaSearchResultIcon, 'Canva', 'large'),
	integrationAri: 'ari:cloud:platform::integration/canva',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Design,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Design],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
